import { PERMISSIONS } from './permissions.js';
export const NOTIFICATION_CATEGORIES = [
    'STOCK_LOW',
    'BATCH_EXPIRING',
    'ORDER_CREATED',
    'INVOICE_OVERDUE',
    'TASK_ASSIGNED',
    'SYSTEM',
    'PRODUCT_SPECIFICATION',
];
export const NOTIFICATION_SEVERITIES = ['INFO', 'SUCCESS', 'WARNING', 'CRITICAL'];
export const NOTIFICATION_CHANNELS = ['channelInApp', 'channelEmail'];
/**
 * Leserecht je Kategorie. Systemweite Meldungen (ohne Empfänger) erreichen nur
 * Benutzer, die den betroffenen Bereich ohnehin einsehen dürfen.
 */
export const NOTIFICATION_CATEGORY_PERMISSION = {
    STOCK_LOW: PERMISSIONS.INVENTORY_READ,
    BATCH_EXPIRING: PERMISSIONS.INVENTORY_READ,
    ORDER_CREATED: PERMISSIONS.DOCUMENT_READ,
    INVOICE_OVERDUE: PERMISSIONS.PURCHASE_READ,
    TASK_ASSIGNED: PERMISSIONS.CUSTOMER_READ,
    SYSTEM: PERMISSIONS.SETTINGS_READ,
    PRODUCT_SPECIFICATION: PERMISSIONS.PRODUCT_SPECIFICATION_READ,
};
/** Vorgabe, solange ein Benutzer keine eigene Einstellung gespeichert hat. */
export const DEFAULT_NOTIFICATION_PREFERENCE = {
    STOCK_LOW: { channelInApp: true, channelEmail: false },
    BATCH_EXPIRING: { channelInApp: true, channelEmail: false },
    ORDER_CREATED: { channelInApp: true, channelEmail: false },
    INVOICE_OVERDUE: { channelInApp: true, channelEmail: true },
    TASK_ASSIGNED: { channelInApp: true, channelEmail: false },
    SYSTEM: { channelInApp: true, channelEmail: false },
    PRODUCT_SPECIFICATION: { channelInApp: true, channelEmail: false },
};
export const NOTIFICATION_PAGE_SIZE = 20;
/** Obergrenze der Glocken-Vorschau; darüber verweist die UI auf die Vollansicht. */
export const NOTIFICATION_PREVIEW_LIMIT = 15;
export const NOTIFICATION_UNREAD_BADGE_MAX = 99;
/** Vorlaufzeit der MHD-Warnung in Tagen (docs/SPEC.md 5.4). */
export const BATCH_EXPIRY_WARNING_DAYS = 30;
/** Tageszeit der wiederkehrenden Prüfläufe in der Zeitzone des Mandanten. */
export const NOTIFICATION_JOBS = [
    { key: 'BATCH_EXPIRING', hour: 6, minute: 0 },
    { key: 'STOCK_LOW', hour: 7, minute: 0 },
    { key: 'INVOICE_OVERDUE', hour: 8, minute: 0 },
];
/** Intervall der SSE-Heartbeats; hält Proxys und Browser-Verbindung offen. */
export const NOTIFICATION_STREAM_HEARTBEAT_MS = 25_000;
export const NOTIFICATION_STREAM_RETRY_MS = 5_000;
//# sourceMappingURL=notifications.js.map